module.exports = __webpack_public_path__ + "img/loading.79701393.gif";